import { useMemo } from 'react'

import { Alert } from '@mui/material'

import {
  COLOR_HANDBALL_ADDED,
  COLOR_MANUAL_POC,
  COLOR_MANUAL_POD,
  COLOR_WAIT_ADDED,
  MANUAL_INTERVENTIONS_INFO,
} from 'components/reports/Metrics/constants/ExceptionMetrics'
import { useGetExceptionMetricsManualInterventionsQuery } from 'generated/graphql'

import { ManualInterventionsCard } from '../components'
import { useExceptionMetricsQueryInput } from './useExceptionMetricsQueryInput'

export const ManualInterventionsMetricCard = () => {
  const { hasValidRange, input } = useExceptionMetricsQueryInput()

  const { data, previousData, loading, error } = useGetExceptionMetricsManualInterventionsQuery({
    variables: { input },
    skip: !hasValidRange,
    notifyOnNetworkStatusChange: true,
    nextFetchPolicy: 'cache-and-network',
  })

  const metrics =
    data?.exceptionMetricsManualInterventions ?? previousData?.exceptionMetricsManualInterventions

  const series = useMemo(
    () => [
      {
        label: 'Wait Time Added',
        color: COLOR_WAIT_ADDED,
        metric: metrics?.waitingTimeChargeAdded,
      },
      {
        label: 'Handball Added',
        color: COLOR_HANDBALL_ADDED,
        metric: metrics?.handballChargeAdded,
      },
      { label: 'POC Added', color: COLOR_MANUAL_POC, metric: metrics?.manualProofOfCollection },
      { label: 'POD Added', color: COLOR_MANUAL_POD, metric: metrics?.manualProofOfDelivery },
    ],
    [metrics],
  )

  if (error) {
    return (
      <Alert severity='error'>Failed to load manual interventions metric. Please try again.</Alert>
    )
  }

  return (
    <ManualInterventionsCard
      titleColor={COLOR_WAIT_ADDED}
      info={MANUAL_INTERVENTIONS_INFO}
      loading={loading && !metrics}
      series={series}
    />
  )
}
